<template>
  <GoogleMapLoader :mapConfig="mapConfig"></GoogleMapLoader>
</template>

<script>
import GoogleMapLoader from './GoogleMapLoader'
import { mapSettings } from '@leapsight/styleguide'

export default {
  name: 'Map',
  components: {
    GoogleMapLoader
  },
  data: () => ({}),
  computed: {
    mapConfig() {
      return {
        ...mapSettings
      }
    }
  }
}
</script>
